import { UserManager, WebStorageStateStore, type User } from 'oidc-client-ts';

/** Cognito group name required for this app (matches ID token `cognito:groups` claim). */
export const COGNITO_SUPERADMIN_GROUP = 'Superadmin';

const COGNITO_GROUPS_CLAIM = 'cognito:groups';

export function userHasSuperadminGroup(user: User | null | undefined): boolean {
  if (!user?.profile) return false;
  const raw = user.profile[COGNITO_GROUPS_CLAIM];
  const groups = Array.isArray(raw) ? raw : raw != null ? [String(raw)] : [];
  return groups.some(
    (g) => typeof g === 'string' && g.toLowerCase() === COGNITO_SUPERADMIN_GROUP.toLowerCase(),
  );
}

const COGNITO_ISSUER = import.meta.env.VITE_COGNITO_ISSUER;
const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN;
const COGNITO_CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID;
const COGNITO_REDIRECT_URI = import.meta.env.VITE_COGNITO_REDIRECT_URI;
const COGNITO_LOGOUT_URI = import.meta.env.VITE_COGNITO_LOGOUT_URI;

export const cognitoUserManagerSettings = {
  authority: COGNITO_ISSUER,
  client_id: COGNITO_CLIENT_ID,
  redirect_uri: COGNITO_REDIRECT_URI,
  response_type: 'code' as const,
  scope: import.meta.env.VITE_COGNITO_SCOPE ?? 'openid email profile',
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTimeInSeconds: 60,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

let cognitoUserManagerInstance: UserManager | null = null;

export const getCognitoUserManager = (): UserManager => {
  if (!cognitoUserManagerInstance) {
    cognitoUserManagerInstance = new UserManager(cognitoUserManagerSettings);
  }
  return cognitoUserManagerInstance;
};

export const cognitoUserManager = getCognitoUserManager();

export const getCognitoSignOutRedirectUrl = (): string => {
  const clientId = COGNITO_CLIENT_ID;
  const logoutUri = COGNITO_LOGOUT_URI;
  return `${COGNITO_DOMAIN}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
};
